var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearchGrey = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "20px",
  height: "20px",
  viewBox: "0 0 20 20",
  style: {
    zoom: 32
  },
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "zoom_out copy") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.11946447,8.97243108 L4.11946447,6.96741855 L4.11946447,8.97243108  Z M20,18.5824561 L18.5427394,20 L14.1740474,15.7463659 L15.6302781,14.3288221 L20,18.5824561  Z M8.23892894,14.0350877 C4.83110196,14.0350877 2.05973223,11.3373434 2.05973223,8.02005013 C2.05973223,4.7037594 4.83110196,2.00501253 8.23892894,2.00501253 C11.6457261,2.00501253 14.4181256,4.7037594 14.4181256,8.02005013 C14.4181256,11.3373434 11.6457261,14.0350877 8.23892894,14.0350877 L8.23892894,14.0350877  Z M8.23892894,0 C3.68795057,0 0,3.59097744 0,8.02005013 C0,12.4491228 3.68795057,16.0401003 8.23892894,16.0401003 C12.7888774,16.0401003 16.4778579,12.4491228 16.4778579,8.02005013 C16.4778579,3.59097744 12.7888774,0 8.23892894,0 L8.23892894,0  Z ",
  id: "zoom_out-copy",
  fill: "#6d838f"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearchGrey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search-grey.608aedc7cb2c7d405399034d10851390.svg";